module.exports = __webpack_public_path__ + "static/media/menuScale.dc086fff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuScale.svg
// module id = 494
// module chunks = 0